<script setup lang="ts">
defineProps<{ txt: stringI18n | undefined; open: boolean | None; classtxt?: string | None }>()
const init3 = useInited('init3')
</script>

<template>
  <div :class="$style.l">
    <span class="_svg16" :class="[$style.i, classtxt]"><slot v-if="init3" /></span>
    <span>
      <span v-if="txt" class="_mr14" :class="classtxt">{{ txt }}</span>
      <slot name="txt" />
    </span>
  </div>

  <UiGrow v-if="typeof open === 'boolean'" :open>
    <slot name="grow" />
  </UiGrow>
</template>

<style module>
.l {
  composes: global(_fw-l);
  composes: global(_ls-xs);
  composes: global(_gap12);
  composes: global(_fs09);
  composes: global(_lh14);
  composes: global(_c1);
  composes: global(_grid);
  composes: global(m_pt04);
  composes: global(m_pb04);

  grid-template: minmax(30px, max-content) / 16px minmax(0, 1fr);
  align-items: center;
  align-content: inherit;
  justify-items: baseline;
  justify-content: unset;
}

.i svg {
  height: 16px;
  width: 16px;
}
</style>
